export const uiSchema = {
  type: 'VerticalLayout',
  elements: [
    {
      type: 'Control',
      scope: '#/properties/copy_configuration_from',
      label: 'Copy Configuration From',
    },
    {
      type: 'Control',
      scope: '#/properties/scan_root',
      label: 'Root tag for scanning (Can be empty)',
    },
    {
      type: 'Control',
      scope: '#/properties/username',
      label: 'OPC Username',
    },
    {
      type: 'Control',
      scope: '#/properties/password',
      label: 'OPC Password',
      options: {
        format: 'password',
      },
    },
    {
      type: 'Control',
      scope: '#/properties/privateKey',
      label: 'Private key',
    },
    {
      type: 'Control',
      scope: '#/properties/certificate',
      label: 'Certificate',
    },
    {
      type: 'Control',
      scope: '#/properties/tls_algo',
      label: 'TLS Algorithm',
    },
    {
      type: 'Control',
      scope: '#/properties/messages',
      label: 'Messages configured',
      options: {
        showSortButtons: false,
        detail: {
          type: 'VerticalLayout',
          elements: [
            {
              type: 'Control',
              scope: '#/properties/id',
              label: 'Message name',
            },
            {
              type: 'Control',
              scope: '#/properties/type',
              label: 'Message type',
            },
            {
              type: 'Control',
              scope: '#/properties/refresh_interval',
              label: 'Refresh Interval for polling',
              rule: {
                effect: 'SHOW',
                condition: {
                  scope: '#/properties/type',
                  schema: { const: 'periodic' },
                },
              },
            },
            {
              type: 'Control',
              scope: '#/properties/trigger',
              label: 'Read',
              rule: {
                effect: 'SHOW',
                condition: {
                  scope: '#/properties/type',
                  schema: { const: 'trigger' },
                },
              },
            },
            {
              type: 'Control',
              scope: '#/properties/comparison',
              label: 'When',
              rule: {
                effect: 'SHOW',
                condition: {
                  scope: '#/properties/type',
                  schema: { const: 'trigger' },
                },
              },
            },
            {
              type: 'Control',
              scope: '#/properties/value',
              label: 'Is',
              rule: {
                effect: 'SHOW',
                condition: {
                  scope: '#',
                  schema: {
                    properties: {
                      comparison: { not: { const: 'changes' } },
                      type: { const: 'trigger' },
                    },
                  },
                },
              },
            },
            {
              type: 'Control',
              scope: '#/properties/props',
              label: 'Parameters to be read',
              options: {
                showSortButtons: false,
              },
            },
          ],
        },
      },
    },
  ],
};
